<!-- <template>
    <nav class="breadcrumb">
      <ul>
        <li v-for="(route, index) in matchedRoutes" :key="index">
          <router-link :to="route.path" class="remove-a-style">{{ route.meta.breadcrumb }}</router-link>
          <span v-if="index < matchedRoutes.length - 1"> <v-icon icon="mdi-chevron-right"></v-icon> </span>
        </li>
      </ul>
    </nav>


  </template> -->
  <template>

    
      <!-- <v-card> -->
        <div class="breadcrumb">
      <ul>
        <li v-for="(step, index) in breadcrumbSteps" :key="index">
          <router-link :to="step.to">{{ step.name }}</router-link>
          <span v-if="index < breadcrumbSteps.length - 1" style="margin:0px;"> <v-icon style="font-size: 22px;" icon="mdi-chevron-right"></v-icon>  </span>
        </li>
      </ul>
    </div>
    <!-- </v-card> -->
  
  </template>
  
  <script>
  export default {
    computed: {
      breadcrumbSteps() {
        const steps = [];
        for (const route of this.$route.matched) {
          if (route.meta && route.meta.breadcrumb) {
            if (Array.isArray(route.meta.breadcrumb)) {
              // Handle routes with multiple step names (as an array)
              for (const step of route.meta.breadcrumb) {
                steps.push({
                  name: step,
                  to: route.path, // You can customize the 'to' property based on your route structure
                });
              }
            } else {
              // Handle routes with a single step name
              steps.push({
                name: route.meta.breadcrumb,
                to: route.path, // You can customize the 'to' property based on your route structure
              });
            }
          }
        }
        return steps;
      },
    },
  };
  </script>


  <!-- <script>
  export default {
    computed: {
      matchedRoutes() {
        return this.$route.matched.filter(route => route.meta && route.meta.breadcrumb);
      },
    },
  };
  </script> -->
  
<style>

.breadcrumb {
  list-style: none;
  margin: 0;
  padding: 0;

  padding:3px 10px;
  border-radius: 3px;
}

.breadcrumb li {
  display: inline;
  margin-right: 5px; 
}

.breadcrumb li a {
  text-decoration: none;
  color: #333; /* Breadcrumb text color */
  font-size:12px;
}

.breadcrumb li span {
  color: #ccc; 
  margin: 0 5px; 
}

.breadcrumb li:last-child span {
  display: none; 
}
.breadcrumb li:last-child>a {
  color:gray;
  opacity: .8;
}
</style>

  